var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9989 6.66667C13.9908 5.21665 13.9265 4.43137 13.4142 3.91912C12.8284 3.33333 11.8856 3.33333 10 3.33333H8C6.11438 3.33333 5.17157 3.33333 4.58579 3.91912C4 4.50491 4 5.44771 4 7.33333V10.6667C4 12.5523 4 13.4951 4.58579 14.0809C5.17157 14.6667 6.11438 14.6667 8 14.6667H10C11.8856 14.6667 12.8284 14.6667 13.4142 14.0809C14 13.4951 14 12.5523 14 10.6667V10",
    stroke: "#003644",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6.66667V10.6667C2 11.7713 2.89543 12.6667 4 12.6667M12 3.33333C12 2.22877 11.1046 1.33333 10 1.33333H7.33333C4.81917 1.33333 3.5621 1.33333 2.78105 2.11438C2.34559 2.54983 2.15291 3.13326 2.06766 4",
    stroke: "#003644",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.8a271caa684bd24a9c5fdf60733fd463.svg";
export { ForwardRef as ReactComponent };